// ----------------------------------------------------------------------------
// Redesign feature flags (Worship Planner web admin only).
// Each one hides a prototype feature that has no backing endpoint or would
// break an existing guard today. All default to false; flip one only once its
// backend support exists. Listed in the redesign gap report.
// ----------------------------------------------------------------------------

export const redesignFlags = {
  /** Song detail: attach a PDF chord chart (upload → parse → review → save). No chart-parsing endpoint exists. */
  pdfCharts: false,
  /** Song detail: section-by-section chord grid. Songs carry no chord chart data today. */
  songChordCharts: false,
  /** Select church: "+ Set up a new church". /create-church is guarded by RequireNoChurch, so it bounces any user who already has one. */
  newChurchFromSelector: false,
  /** Invite codes: a per-code enable/disable switch. The API only generates and revokes. */
  inviteCodeToggle: false,
  /** Join by code: preview the church before requesting. No lookup-by-code endpoint; joining is the only call. */
  inviteChurchPreview: false,
  /** Song Studio rows: retry analysis of a failed upload. No re-analyze endpoint for an existing record. */
  songStudioRetry: false,
  /** Roster: "Remind pending" for unconfirmed people only. The replay endpoint re-sends to the whole team. */
  rosterRemindPending: false,
  /** New-plan wizard: per-service "Email lyrics when published". Lyrics email is a church setting; the plan DTO has no flag. */
  wizardLyricsToggle: false,
  /** Members: editable positions (Vocals, Keys...). Memberships carry a role only; there is no positions field. */
  memberPositions: false,
  /** Church settings: time zone. The church record has no time zone field. */
  churchTimeZone: false,
  /** Profile: phone number. The user record and profile update carry username and email only. */
  profilePhone: false,
  /** Plan: Monthly / Yearly toggle. Tiers have monthly prices only and checkout takes no billing interval. */
  yearlyBilling: false,
  /** Billing: card brand, last four and expiry. The API has no payment-method endpoint; the card is managed in the Stripe portal. */
  billingCardDetails: false,
} as const;
